import { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { MutationResult } from '../../../../shared/types/query';
import { PublicApiFormState } from '../types/publicApi';
import { KEY_PUBLIC_API_TOKEN_LIST } from './useGetTokens';

export const KEY_GENERATE_PUBLIC_API_TOKEN = 'configuration/key_generate_public_api_token';

export function useGeneratePublicApiToken(): MutationResult<PublicApiFormState, AxiosResponse> {
  const http = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [KEY_GENERATE_PUBLIC_API_TOKEN],
    mutationFn: async ({ name, timeToLive }: PublicApiFormState) => {
      return http.request({
        method: 'post',
        url: 'ApiClient',
        data: {
          name, timeToLive
        }
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries([KEY_PUBLIC_API_TOKEN_LIST])
    }
  })
}